module.exports = __webpack_public_path__ + "img/headsup-logo-2.png";